export default __webpack_public_path__ + "static/media/back.cab0383a.jpeg";